import commonStyles from '../../styles/commonStyles.module.css';

//
//

type ErrorMessageProps = {
  message?: string;
};

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  if (!message) return null;

  //

  return <p className={`${commonStyles.errorMessage} delayed-fadein`}>{message}</p>;
};
